import { Component, OnInit } from '@angular/core';
import { NgIf } from '@angular/common';
import { BffService } from '../../services/BffService';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-bff-controls',
  standalone: true,
  imports: [NgIf],
  template: `
    <div *ngIf="isBff" style="padding:1rem">
      <h3>BFF Controls (dev)</h3>
      <button (click)="signInCustomer()">Sign in as Customer</button>
      <button (click)="signInEmployee()" style="margin-left: 8px;">Sign in as Employee</button>
      <button (click)="signOut()" style="margin-left: 8px;">Sign out</button>
      <div style="margin-top: 0.5rem; font-size: 0.9rem; color: #666;">
        CSRF cookie is issued automatically; state-changing calls include X-CSRF-TOKEN.
      </div>
    </div>
  `,
})
export class BffControlsComponent implements OnInit {
  isBff = environment.authMode === 'bff';
  constructor(private bff: BffService) {}
  async ngOnInit() {
    if (this.isBff) {
      await this.bff.ensureCsrf();
    }
  }
  signInCustomer() { this.bff.signInCustomer(); }
  signInEmployee() { this.bff.signInEmployee(); }
  async signOut() { await this.bff.signOut(); }
}

